import { combineUrlAndParams } from "@nens/shared-utils";

export function getWmsRequest(
  url: string,
  params: {
    layer: string;
    styles?: string;
    transparent: boolean;
    time?: string | null;
  }
) {
  const { layer, styles, transparent, time } = params;
  const wmsParams: Record<string, string | number | boolean> = {
    SERVICE: "WMS",
    REQUEST: "GetMap",
    VERSION: "1.1.1",
    SRS: "EPSG:3857",
    LAYERS: layer,
    FORMAT: "image/png",
    TRANSPARENT: transparent,
    HEIGHT: 256,
    WIDTH: 256,
  };

  if (styles) wmsParams["STYLES"] = styles;
  if (time) wmsParams["TIME"] = time;

  const wmsUrl = combineUrlAndParams(url, wmsParams);

  // The "{bbox-epsg-3857}" placeholder string cannot be used inside params thus below solution
  // Note: this bbox string can only be used with react-map-gl
  const wmsUrlWithBoundingBox = wmsUrl + "&BBOX={bbox-epsg-3857}";

  return wmsUrlWithBoundingBox;
}
